// extracted by mini-css-extract-plugin
export default {"locationIcon":"EditLocationItemModal_locationIcon__XO8gZ","smallPrice":"EditLocationItemModal_smallPrice__TVa+h"};